import { Group, Text, UnstyledButton } from '@mantine/core';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import { ReactElement } from 'react';
import { INBOX_TOOLBAR_CHIP_STYLE } from '@/components/InboxSort';

export interface FutureTasksToggleProps {
  /** True when tasks due after today are in the list. */
  value: boolean;
  onChange: (showFutureTasks: boolean) => void;
}

/**
 * Sits beside the inbox sort control. Off by default (BAR-2679): the inbox
 * lists only tasks due today or overdue, and this reveals the rest.
 * Shares `INBOX_TOOLBAR_CHIP_STYLE` with `InboxSortDropdown` so the two read as one toolbar.
 */
export function FutureTasksToggle({ value, onChange }: FutureTasksToggleProps): ReactElement {
  return (
    <UnstyledButton
      aria-pressed={value}
      onClick={() => onChange(!value)}
      style={{
        ...INBOX_TOOLBAR_CHIP_STYLE,
        backgroundColor: value ? 'var(--mantine-color-blue-0)' : undefined,
      }}
    >
      <Group gap={6} wrap="nowrap">
        {value ? <IconEye size={14} stroke={1.5} /> : <IconEyeOff size={14} stroke={1.5} />}
        <Text size="sm">{value ? 'Hide future tasks' : 'Show future tasks'}</Text>
      </Group>
    </UnstyledButton>
  );
}
